import { useCallback } from 'react';
import { TableState } from 'react-table';
import { useLocalStorage } from '../../LocalStorage';

export const useGetPersistentDataGridSettings = <T extends object>(
  namespace: string,
  tableId: string,
  userId: string,
): TableState<T> | undefined => {
  const { get } = useLocalStorage();
  const effectiveId = `[ns=${namespace}][table=${tableId}][userId=${userId}]`;

  const value = get<T>(effectiveId) as TableState;

  return value;
};

export const usePutPersistentDataGridSettings = <T extends object>(
  namespace: string,
  tableId: string,
  userId: string,
) => {
  const { set } = useLocalStorage();
  return useCallback(
    (value: TableState<T>): void => {
      const effectiveId = `[ns=${namespace}][table=${tableId}][userId=${userId}]`;
      set<TableState>(effectiveId, value);
    },
    [tableId, namespace, userId, set],
  );
};
